import { createSelector } from 'reselect';
import { getEntitySelector } from '../selectors';
import { ENTITIES_KEY_COLOR } from './index';

export const getColorEntities = (state) => getEntitySelector(state, ENTITIES_KEY_COLOR);

export const getColors = createSelector(getColorEntities, (colorEntities) => {
    if (!colorEntities) {
        return [];
    }
    const { allIds = [], ...colors } = colorEntities;
    return allIds.map((colorId) => colors[colorId]);
});
